var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.message)?_c('div',{class:[
      'fixed top-8 left-1/2 -translate-x-1/2 px-5 py-2 rounded shadow-lg z-[1000] text-white text-center',
      _vm.win ? 'bg-green-600 dark:bg-green-700' : 'bg-red-400 dark:bg-gray-800',
    ],staticStyle:{"min-width":"260px","white-space":"nowrap"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }